import { InsuranceCoverageMonitorSettings } from "../../../../../services/api/insurance/monitor/types";

export const selectorPolicyTypesFromSettings = (
  insuranceCoverageMonitorSettings?: InsuranceCoverageMonitorSettings
) => {
  return insuranceCoverageMonitorSettings?.coverages?.map(
    coverage => coverage.policyType
  );
};
